"use strict";

export function initInScope($scope) {
    if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) {
        console.log("enumerateDevices() not supported.");
        return;
    }

    const constraints = {
        video: {
            aspectRatio: { ideal: 4/3 },
            facingMode: { ideal: "user" },
        }
    };

    $scope.find('.js-take-photo').each(function (index, container) {
        let $container = $(container),
            $input = $container.find('.js-take-photo__input'),
            $canvas = $container.find('.js-take-photo__context')[0],
            context = $canvas.getContext('2d');

        let player = $container.find('.js-take-photo__stream')[0];

        $container.find('.js-take-photo__toggle').on('click', function () {
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                if ($container.hasClass('is-open')) {
                    $container.removeClass('is-open');
                    player.srcObject.getVideoTracks().forEach(track => track.stop());
                } else {
                    $container.addClass('is-open');
                    player.srcObject = stream;
                }
            });
        });

        //make image
        $container.find('.js-take-photo__capture').on('click', function () {
            let videoWidth = player.videoWidth;
            let videoHeight = player.videoHeight;
            let canvasWidth = $canvas.width;
            let canvasHeight = $canvas.height;

            // Check if video is portrait oriented
            if (videoHeight > videoWidth) {
                // Calculate crop dimensions to maintain aspect ratio
                let scale = canvasWidth / videoWidth;
                let scaledHeight = videoHeight * scale;
                let cropY = (scaledHeight - canvasHeight) / 2 / scale;
                let cropHeight = canvasHeight / scale;

                // Draw cropped portrait image
                context.drawImage(player, 0, cropY, videoWidth, cropHeight, 0, 0, canvasWidth, canvasHeight);
            } else {
                // Draw landscape or square image normally
                context.drawImage(player, 0, 0, canvasWidth, canvasHeight);
            }

            $container.addClass('has-photo');
        });

        //try again
        $container.find('.js-take-photo__retry').on('click', function () {
            $container.removeClass('has-photo');
        });

        //select image
        $container.find('.js-take-photo__submit').on('click', function () {
            $container.removeClass('is-open');
            $container.addClass('is-selected');
            player.srcObject.getVideoTracks().forEach(track => track.stop());

            let imageData = $canvas.toDataURL('image/png')
            $input.val(imageData);
            $input.prop('required', true);

            $container.find('.js-take-photo__upload').prop('required', false);
            $container.find('.js-take-photo__preview').attr('src', imageData).attr('hidden', false).trigger('change');
            $container.closest('form').trigger('change');
        });

        //remove selected image
        $container.find('.js-take-photo__clear').on('click', function () {
            $container.removeClass('is-selected');
            $input.val('');
            $input.prop('required', false);
            $container.find('.js-take-photo__upload').prop('required', true);
            $container.closest('form').trigger('change');
        })
    });
}
